import { Alert, Box, Button, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import axios from 'axios'
import React from 'react'
import { useState } from 'react'
import {newBaseUrl} from './../utils/capitalRequest';
const InsertNewUsers = () => {

  const [InputValue, setInputValue] = useState("")
  const [Loading, setLoading] = useState(false);

  const [Message, setMessage] = useState({status:false,type:"",message:""});

  const submitData = () => {
    setLoading(!Loading)
    let al = InputValue.replaceAll(/\n/g,'');
    axios.post(`${newBaseUrl}/import/user`, {email:al})
    .then(res=>{
      const {data, message} = res.data;
      setInputValue("");
      setLoading(false)
      setMessage({
        status:true,
        type:"success",
        message:message
      })
    })
    .catch(err=>{
      setLoading(false)
      console.log(err)
      setMessage({
        status:true,
        type:"error",
        message:"Something went wrong!"
      })
    })
  }

  return (
    <>
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {
              Message.status && (
                <Alert severity={Message.type}>{Message.message}</Alert>
              )
            }

            <Typography variant='h6'>Insert Users</Typography>
            <Divider sx={{ my:1 }} />
          </Grid>
          <Grid item xs={6}>
            <Box>
              <textarea onChange={(e)=>setInputValue(e.target.value)} rows={6} style={{ 
                width:'100%'
               }} value={InputValue} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              {
                Loading ?
                <>
                  <CircularProgress />
                </>
                :
                <>
                <Button onClick={()=>submitData()} variant='contained' >Submit</Button>
                </>

              }
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default InsertNewUsers